import styled from 'styled-components'
import { colors } from '../../../components/SalesReport/tokens'

const MOBILE = '@media (max-width: 767px)'

export const Content = styled.section`
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 0;

  ${MOBILE} {
    gap: 16px;
  }
`

export const Kpis = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 24px;

  ${MOBILE} {
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;
  }
`

export const Groups = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const MobileSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const MobileGroupRows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  &[hidden] {
    display: none;
  }
`

export const PartialNote = styled.p`
  margin: 8px 0 0;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: ${colors.ink500};
`

export const ToggleAll = styled.button`
  align-self: flex-end;
  padding: 4px 0;
  border: 0;
  background: transparent;
  font-size: 13px;
  font-weight: 600;
  line-height: normal;
  color: ${colors.primaryStrong};
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }

  @media print {
    display: none;
  }
`

export const StockNote = styled.p`
  margin: 0;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: ${colors.ink500};
`

export const ShowMore = styled.button`
  align-self: center;
  padding: 8px 16px;
  border: 1px solid ${colors.border};
  border-radius: 9999px;
  background: ${colors.white};
  color: ${colors.ink800};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }

  @media print {
    display: none;
  }
`

export const MobileProgress = styled.p`
  margin: 0;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  color: ${colors.ink500};

  @media print {
    display: none;
  }
`
